<template>
  <div class="reports__view">
    <tab-navigation-panel :tabs="reports"></tab-navigation-panel>
    <router-view></router-view>
  </div>
</template>

<script>
  import TabNavigationPanel from "@/components/TabNavigationPanel.vue";
  import { mapActions, mapGetters } from "vuex";

  export default {
    name: "reports-view",
    components: { TabNavigationPanel },
    data: () => ({
      reports: [
        //{ label: "Afløser Statistik", name: "ReplacementStatistics" },
        { label: "Generel Statistik", name: "GeneralStatistics" },
        { label: "Kørsel Statistik", name: "DriveStatistics" },
        { label: "Afspadsering/Ferie", name: "TimeOff" },
        // { label: "Afløser Månedlig Statistik", name: "ReplacementMonthlyStatistics" },
        { label: "Sygedage Statistik", name: "AbsenceStatistics" },
        { label: "Månedlig Statistik", name: "MonthlyStatistics" },
        { label: "Månedlig Gruppe", name: "MonthlyGroup" },
        {
          label: "Årlig timeregistreringsudtræk",
          name: "YearlyTimeRegistration",
        },
        //{ label: "Løn rapport", name: "SalaryReport" },
      ],
      adminNumbers: ['1016', '1010', '1011']
    }),
    mounted() {
      if (this.isAdmin === false) {
        this.reports = [
          { label: "Månedlig Statistik", name: "MonthlyStatistics" },
          { label: "Månedlig Gruppe", name: "MonthlyGroup" },
          {
            label: "Årlig timeregistreringsudtræk",
            name: "YearlyTimeRegistration",
          },
          // { label: "Møder mm.", name: "AbsenceStatistics" },
          // { label: "Fridage", name: "AbsenceStatistics" },
        ];
      }

      this.reports.push({ label: "DT rapport", name: "DTReport" });

      const number = this.currentUser.number.toString();
      if (this.adminNumbers.find(f => f === number) || number === "1012" || this.currentUser.isSalaryReportOpen) {
        this.reports.push({ label: "Løn rapport", name: "SalaryReport" });
        this.reports.push({ label: "Dagsrapport", name: "SalaryDayReport" });
      }
      if (this.adminNumbers.find(f => f === number)) {
        this.reports.push({ label: "Total Løn rapport", name: "TotalSalaryReport" });
      }
    },
    computed: {
      ...mapGetters("entrySidebar", ["entrySidebarModel"]),
      ...mapGetters(["currentUser", "isAdmin"]),
    },
  };
</script>

<style lang="scss">
  .reports__view {
    width: calc(100vw - 16.5px);

    .cell-time {
      background: rgb(208, 241, 252) !important;
    }
    .cell-note {
      background: rgb(252, 249, 208) !important;
    }

    .reports__navigation {
      background-color: $panel;
      height: 44px;
      display: flex;
      flex-flow: row wrap;
      align-content: center;
      padding: 0 12px;
    }

    .reports__subheader {
      background-color: $panel;
      padding: 5px 12px;
      height: 62px;

      display: flex;
      flex-flow: row wrap;
      gap: 5px;

      .datepicker {
        input {
          height: 30px !important;
          padding-top: 1px;
          padding-bottom: 2px;
        }
      }
      .ctrl-button {
        width: 100%;
      }
    }

    .field:not(:last-child) {
      margin-bottom: 0.2em;
    }
    label {
      margin-bottom: initial;
      font-size: 0.75em;
      font-weight: 600;
      &:not(:last-child) {
        margin-bottom: initial;
      }
    }

    tr.column-sunday {
      color: white;
      background: rgb(77, 77, 77);
      padding: 0.5em 0.75em;
      margin: -0.5em -0.75em;
    }
    tr.column-holiday {
      color: black;
      background: rgb(255, 243, 70);
      padding: 0.5em 0.75em;
      margin: -0.5em -0.75em;
    }
  }
  @media print {
    .tabnavigationpanel {
      display: none;
    }
    .reports__subheader {
      font-size: 10px !important;
      line-height: 1 !important;
      height: 47px !important;
    }
  }
</style>
